#@import _
#@import Booking.Presenters.Base
#@export Booking.Presenters.Option

class Booking.Presenters.Option extends Booking.Presenters.Base

  isUrgencyPricingOption: (pricingMetadata) ->
    return false unless pricingMetadata and pricingMetadata isnt {} and pricingMetadata.offerType isnt 'BWF'

    {offerBeginsAt, offerEndsAt} = pricingMetadata
    now = new Date()
    urgencyPricingStartsAt = new Date offerBeginsAt if offerBeginsAt?
    urgencyPricingEndsAt = new Date offerEndsAt if offerEndsAt?

    (urgencyPricingStartsAt <= now <= urgencyPricingEndsAt) or
    (not urgencyPricingEndsAt? and urgencyPricingStartsAt <= now) or
    (not urgencyPricingStartsAt? and urgencyPricingEndsAt >= now)

  getSoldQuantityMessageLocalesString: (showQuantity, quantity, quantityMessage) ->
    unless showQuantity
      return null
    unless quantityMessage.slice(-1) is '+'
      return {localesString: 'quantity_bought', quantity: quantity}
    if quantityMessage.indexOf(quantity)+1
      return {localesString: 'over_quantity_bought', quantity: quantity}
    else
      return {localesString: 'quantity_bought', quantity: quantityMessage}

  toHash: ->

    pricingMetadata = @model.getPricingMetadata()
    optionId = @model.id
    selectedOptionId = @parentModel.getSelectedOption()?.id

    discount = @model.getDiscount()
    showDiscount = @model.getShowDiscount() and discount?.amount > 0
    showQuantity = @model.getShowQuantity()
    soldQuantity= @model.getSoldQuantity()
    soldQuantityMessage= @model.getSoldQuantityMessage()

    price = @model.getFormattedPrice()

    isUrgencyPricing = @isUrgencyPricingOption(pricingMetadata)
    showUrgencyPricingMessage = isUrgencyPricing and price? and showDiscount

    localesBasePath = @localesBasePath()
    quantityNumber = @getI18n().toNumber soldQuantity
    soldQuantityMessageLocalesString = @getSoldQuantityMessageLocalesString(showQuantity, quantityNumber, soldQuantityMessage)
    if soldQuantityMessageLocalesString
      soldQuantityMessageText = @getI18n().t "js.#{localesBasePath}.#{soldQuantityMessageLocalesString.localesString}", quantity: soldQuantityMessageLocalesString.quantity

    optionId:     optionId
    title:        @model.getTitle()
    selected:     selectedOptionId is optionId
    isSoldOut:    @model.isSoldOut()
    price: price
    value: @model.getFormattedValue()
    isUrgencyPricing: isUrgencyPricing
    showUrgencyPricingMessage: showUrgencyPricingMessage
    offerLabel: pricingMetadata?.offerLabel
    discount: discount?.formattedAmount
    showDiscount: showDiscount
    soldQuantityMessageText: soldQuantityMessageText

  bhc: ->
    "dealoption:#{@model.getTitle()}"
